import React from "react";
import Button from "../utils/Button";

const Header = ({ toggleTheme, theme }) => {
  return (
    <header>
      <section className="container">
        <div className="title-box">
          <h2>Social Media Dashboard</h2>
          <p>Total followers: 23,004</p>
        </div>
        <div className="btn-box">
          <p>Dark Mode</p>
          <Button toggleTheme={toggleTheme} theme={theme} />
        </div>
      </section>
    </header>
  );
};

export default Header;
